import { render, staticRenderFns } from "./SettingsPayment.vue?vue&type=template&id=73458f69&"
import script from "./SettingsPayment.vue?vue&type=script&lang=js&"
export * from "./SettingsPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SettingsPayment.vue"
export default component.exports